import React from 'react'
import {
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import Lock from '@mui/icons-material/Lock'
import MedicalServices from '@mui/icons-material/MedicalServices'

const levelColor = (level) => {
  switch (level) {
    case 'Advanced':
      return '#DC2626'
    case 'Intermediate':
      return '#9B287B'
    case 'Specialist':
      return '#1F3D7C'
    default:
      return '#1E7F88'
  }
}

const TopBar = ({ bag, view, setView }) => {
  const navigate = useNavigate()
  const color = levelColor(bag.level)
  const sealRemoved = bag.tagNumber === 'Removed'

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        p: 2,
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        backgroundColor: '#fff',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.5}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'center' }}
      >
        <Stack direction="row" spacing={1.25} alignItems="center" minWidth={0}>
          <Button
            variant="outlined"
            onClick={() => (view !== 'home' ? setView('home') : navigate(-1))}
            sx={{ minWidth: 36, width: 36, height: 36, borderRadius: 1.5, p: 0 }}
          >
            <ArrowBackIcon fontSize="small" />
          </Button>

          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 1.5,
              display: 'grid',
              placeItems: 'center',
              color,
              backgroundColor: `${color}14`,
              flexShrink: 0,
            }}
          >
            <MedicalServices />
          </Box>

          <Stack minWidth={0}>
            <Typography variant="h5" fontWeight={950} noWrap>
              {bag.name || 'Medicine Bag'}
            </Typography>
            <Typography variant="caption" color="text.secondary" noWrap>
              {bag.number ? `Bag ${bag.number}` : 'Staff bag check'}
            </Typography>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
          {bag.level && (
            <Chip
              label={bag.level}
              size="small"
              sx={{
                borderRadius: 1,
                color,
                backgroundColor: `${color}12`,
                fontWeight: 850,
              }}
            />
          )}
          <Chip
            label={bag.tagNumber || 'No seal'}
            size="small"
            color={sealRemoved ? 'error' : 'success'}
            icon={sealRemoved ? <LockOpenIcon /> : <Lock />}
            sx={{ borderRadius: 1, fontWeight: 850 }}
          />
        </Stack>
      </Stack>
    </Paper>
  )
}

export default TopBar
